import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const dismissOutstandingBalance = {
  name: "dismissOutstandingBalance" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
